<template>
    <pendo-multiselect
        class="single-app-chooser single-select-filter-apps"
        :loading="isLoading"
        :value="selectedApp"
        :options="loadedAppOptions"
        :allow-empty="false"
        :placeholder="$t('singleAppChooser.Select an app')"
        label-key="displayName"
        :group-dividers="true"
        group-label-key="group"
        group-options-key="apps"
        :searchable="false"
        :disabled="disabled"
        @input="setApplication">
        <template #selectedLabel="{ option }">
            <pendo-app-display
                v-if="isAppSet"
                :apps="option" />
        </template>
        <template #header="{ comboboxAttrs, handleKeydown, updateInputValue, inputValue }">
            <div class="app-search-container">
                <search
                    v-bind="comboboxAttrs"
                    :value="inputValue"
                    class="app-chooser-search"
                    autofocus
                    full-width
                    :placeholder="$t('singleAppChooser.Search apps...')"
                    @input="updateInputValue"
                    @keydown="handleKeydown" />
            </div>
        </template>
        <template #option="{ option }">
            <div class="selector-option-wrapper">
                <pendo-app-display
                    class="app-name"
                    :apps="option" />
            </div>
        </template>
    </pendo-multiselect>
</template>
<script>
import { PendoMultiselect, PendoAppDisplay } from '@pendo/components';
import Search from '@/common/search/search.vue';
import { AppChooserService } from '@/common/app-chooser/app-chooser.service';
import { mapActions } from 'vuex';

export default {
    name: 'SingleAppChooser',
    components: {
        PendoMultiselect,
        PendoAppDisplay,
        Search,
    },
    props: {
        appOptionsConfig: {
            type: {},
            default: () => {},
        },
        appOptions: {
            type: Array,
            default: undefined,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        selectedApp: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['setApplication'],
    computed: {
        isAppSet () {
            return !!this.selectedApp;
        },
        loadedAppOptions () {
            if (this.appOptions) {
                return this.appOptions;
            }

            return AppChooserService.formatOptions(...Object.values(this.appOptionsConfig));
        },
    },
    async created () {
        await this.loadAllApps();
    },
    methods: {
        ...mapActions({
            loadAllApps: 'apps/loadAll',
        }),
        setApplication (app) {
            this.$emit('setApplication', app);
        },
    },
};
</script>

<style lang="less" scoped>
.app-search-container {
    padding: 8px 16px;
    border-bottom: 1px solid var(--palette-gray-30);
}
</style>
